import { render, staticRenderFns } from "./BackToSearch.vue?vue&type=template&id=56f3beee"
import script from "./BackToSearch.vue?vue&type=script&lang=ts"
export * from "./BackToSearch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports